<div class="column-flex align-center-flex auto-flex">
  <div class="margin-10">
    <div *ngIf="survey && survey.JobMaster" class="comm-edtr-diyEdtr-container">
      <div>
        <app-timezone-picker [guess]="true" [timezone]="schedules[0]?.timezone" (timezoneChange)="timezoneChanged($event)"></app-timezone-picker>
      </div>
      <div>
        <mat-form-field appearance="outline" style="width:280px">
          <mat-label>Enter a date/time range</mat-label>
          <app-datetime-range-input [formGroup]="timings" [rangePicker]="picker">
            <input appStartDatetime formControlName="start" placeholder="Start date">
            <input appEndDatetime formControlName="end" placeholder="End date">
          </app-datetime-range-input>
          <app-datetime-picker-toggle matIconSuffix [for]="picker"></app-datetime-picker-toggle>
          <app-datetime-range-picker #picker></app-datetime-range-picker>

          @if (timings.controls.start.hasError('matStartDateInvalid')) {
          <mat-error>Invalid start date/time</mat-error>
          }
          @if (timings.controls.end.hasError('matEndDateInvalid')) {
          <mat-error>Invalid end date/time</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </div>
  <mat-accordion class="surv-schedular-accordion">
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          More Options
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <h3>Invite Windows</h3>
        <p>
          Invite Windows allow you to control (within the schedule) when invites can go out. This is particularly useful when you
          have SMS going out that take time to send and you only want them to go out within specific windows of time so that
          it does not annoy the recipients. Use multiple windows to refine the times for different days and/or multiple times on the same day.<br /><br />
          Note: For invites using mobile numbers, all times are adjusted based on the destination country of the message being sent.
        </p>
        <app-window #messageWindows (onChange)="onWindowChange($event)" [model]="windows"></app-window>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
 </div>
